import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/style.css'
import './styles/icon/iconfont.css'
import './styles/icon_search/iconfont.css'
import routes from './router'
import 'font-awesome/css/font-awesome.min.css'
import './styles/flag-icon/css/flag-icon.min.css'
// require('vue2-animate/dist/vue2-animate.min.css')
// import "vue2-animate/src/less/vue2-animate.less";
//yu、xk、an  无
import store from './store/store'
import * as types from './store/types'
import VueScrollTo from 'vue-scrollto'
import axios from './http'
import Auth from './auth'
import VueI18n from 'vue-i18n'
import messages from './lan/index'
import filter from './filter/index'
import utils from './utils'
import VueQriously from 'vue-qriously' // 二维码
import VueAwesomeSwiper from 'vue-awesome-swiper' // 轮播
import 'swiper/dist/css/swiper.css'
import { ipCountry } from '@/api/api'
// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.use(VueQriously)
Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(babelpolyfill)
Vue.use(VueScrollTo)
Vue.use(VueI18n)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$utils = utils
// 页面刷新时，重新赋值token
if (window.localStorage.getItem('token')) {
  store.commit(types.LOGIN, window.localStorage.getItem('token'))
}
if (window.localStorage.getItem('level')) {
  store.commit(types.LEVEL, window.localStorage.getItem('level'))
}
if (window.localStorage.getItem('user')) {
  store.commit(types.USER, window.localStorage.getItem('user'))
}
if (window.localStorage.getItem('channel')) {
  store.commit(types.CHANNEL, window.localStorage.getItem('channel'))
}

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: routes,
})

Vue.$auth = new Auth(router, axios, store)

router.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (store.state.token) {
      next()
    } else {
      var customSettings = window.localStorage.getItem('customSettings')
      var query = { redirect: to.fullPath }
      if (customSettings) {
        customSettings = JSON.parse(customSettings)
        if (customSettings.logo) {
          query.logo = decodeURIComponent(customSettings.logo)
          query.color = customSettings.color
        }
      }
      next({
        path: '/login',
        query: query,
      })
    }
  } else {
    next()
  }
  //面包屑导航
  if (to.meta.crumbs && to.meta.crumbs.length > 0) {
    store.commit(types.ADDCRUMBS, to.meta.crumbs)
  }
  store.commit(types.CURRENTNAME, to.meta.self_name)
  //ip判断
  if (
    window.sessionStorage.getItem('ip_isCn') === 'true' ||
    window.sessionStorage.getItem('ip_isCn') === 'false'
  ) {
    next()
  } else {
    ipCountry().then((res) => {
      let ip_isCn = res.data.ret === 0 ? true : false
      window.sessionStorage.setItem('ip_isCn', ip_isCn)
      next()
    })
  }
})

router.afterEach(function (to) {
  if (to.query.reg_from) {
    window.sessionStorage.setItem('reg_from', to.query.reg_from)
  }
})

//begin语言设置
function lang() {
  // 将选择的语言存在localStorage中
  return 'cn'
  let t = window.localStorage.getItem('language')
  if (t) {
    return t
  } else {
    window.localStorage.setItem('language', 'cn')
    return 'cn'
  }
}
const language = lang()
// 自定义 window 的 lang 属性
window.lang = lang()
// 创建一个 i18n 实例
const i18n = new VueI18n({
  locale: language, // 语言标识
  messages,
})
//end 语言设置
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js